export default "__VITE_ASSET__CDcbQQCo__"